import { render, staticRenderFns } from "./maconfig-add-or-update.vue?vue&type=template&id=535e09a6&"
import script from "./maconfig-add-or-update.vue?vue&type=script&lang=js&"
export * from "./maconfig-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports